export enum Breakpoints {
  WIDE_MOBILE_MIN = 450,
  MOBILE_BREAKPOINT = 601,
  TABLET_MIN = 700,
  DESKTOP_MIN = 1024,
  MONITOR_MIN = 1400
}
